"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EventConfigurationPageTransportationPanes;
(function (EventConfigurationPageTransportationPanes) {
    EventConfigurationPageTransportationPanes[EventConfigurationPageTransportationPanes["TransportOptions"] = 1] = "TransportOptions";
    EventConfigurationPageTransportationPanes[EventConfigurationPageTransportationPanes["VendorAccess"] = 2] = "VendorAccess";
    EventConfigurationPageTransportationPanes[EventConfigurationPageTransportationPanes["TermsAndConditions"] = 3] = "TermsAndConditions";
})(EventConfigurationPageTransportationPanes || (EventConfigurationPageTransportationPanes = {}));
exports.default = EventConfigurationPageTransportationPanes;
